import { WhatsappBusinessApiPhone } from "@whatslly/types/waba/WhatsappBusinessApiGetPhones";
import { TwilioPhone } from "@whatslly/types/twilio/TwilioGetPhones";
import { IMessagePhone } from "@whatslly/types/imessage/IMessagePhone";
import { IMMessage } from "./services/IMMessage";
import type { ImMessage } from "@whatslly/types/tuvis-messaging/TuvisMessagingMessages";

export const TuvisMessagingProviderSymbol = Symbol.for("TuvisMessagingProviderSymbol");

export interface ITuvisMessagingProvider {
  etoken: string;
  pod: string;
  getMe?: () => Promise<{ phone: string; appleId: string }>;
  getPhones?: () => Promise<Array<WhatsappBusinessApiPhone | TwilioPhone | IMessagePhone>>;
  newMessagesEmitter?: any;
  getMessages?: () => Promise<IMMessage[]>;
  checkForIMessagePermission?: () => Promise<any>;
  sendMessage?: (id: string, message: string) => Promise<void>;
  getOrgId: () => Promise<string | undefined>;
  init?: () => Promise<void>;
  onIncomingMessage?: (message: ImMessage) => void;
}
